<ng-container *ngIf="columnLeftView === 0">
    <div class="left-header" [style.background-color]="selectedGate?.backColor?.web || null"
        [style.color]="selectedGate?.foreColor?.web || null">
        <options class="show-label no-title left" [optionstrip]="gateOptions"
            [colorForced]="selectedGate?.foreColor?.web || null" (clickOption)="clickGateOption.emit($event)">
        </options>
        <div class="title" *ngIf="selectedGate">
            {{selectedGate.gateName}}
        </div>
    </div>
    <div class="gate-routes" (drop)="drop($event, selectedGate)">
        <shared-forklift-left-route
            *ngFor="let route of selectedGatePlates | orderbyaccesscontrolgateplatedto:true | filter:searchText"
            [value]="route" [selectedRoute]="selectedRoute" (clickRoute)="clickRoute.emit($event)"
            (dblClickRoute)="dblClickRoute.emit($event)"
            [ngClass]="{selected: selectedRoute?.phaseId === route?.phaseId}"></shared-forklift-left-route>
    </div>
</ng-container>

<div class="gates-body" *ngIf="columnLeftView === 1">
    <div class="gates-strip" *ngIf="closedGates.length > 0">
        <div class="gate-strip-item" *ngFor="let gate of closedGates | sortBy: '-gateOrder'"
            [style.background-color]="gate.backColor?.web || null" [style.color]="gate.foreColor?.web || null"
            (click)="toggleGate(gate)">
            {{ gate.gateName }}
        </div>
    </div>
    <div class="gate-column" *ngFor="let gate of openGates | sortBy: 'gateOrder'">
        <div class="gate-header gate-header-toggle" [style.background-color]="gate.backColor?.web || null"
            [style.color]="gate.foreColor?.web || null" (click)="toggleGate(gate)">
            {{ gate.gateName }}
        </div>
        <div class="gate-routes" (drop)="drop($event, gate)">
            <shared-forklift-left-route
                *ngFor="let route of gate.plates | orderbyaccesscontrolgateplatedto:true | filter:searchText"
                [value]="route" [selectedRoute]="selectedRoute" (clickRoute)="clickRoute.emit($event)"
                (dblClickRoute)="dblClickRoute.emit($event)"
                [ngClass]="{selected: selectedRoute?.phaseId === route?.phaseId}"></shared-forklift-left-route>
        </div>
    </div>
</div>

<div class="gates-body" *ngIf="columnLeftView === 2">
    <div class="gate-column" *ngFor="let gate of gates | sortBy: 'gateOrder'">
        <div class="gate-header" [style.background-color]="gate.backColor?.web || null"
            [style.color]="gate.foreColor?.web || null">{{ gate.gateName }}</div>
        <div class="gate-routes" (drop)="drop($event, gate)">
            <shared-forklift-left-route
                *ngFor="let route of gate.plates | orderbyaccesscontrolgateplatedto:true | filter:searchText"
                [value]="route" [selectedRoute]="selectedRoute" (clickRoute)="clickRoute.emit($event)"
                (dblClickRoute)="dblClickRoute.emit($event)"
                [ngClass]="{selected: selectedRoute?.phaseId === route?.phaseId}"></shared-forklift-left-route>
        </div>
    </div>
</div>